export default "__VITE_ASSET__BIQJycOZ__"